/* ============================================================
   Aevex Verdict & Scorecard — Animations
   ============================================================ */
(function () {
  'use strict';

  /* ---- Helpers ---- */
  function getColorClass(score) {
    if (score >= 85) return 'excellent';
    if (score >= 70) return 'good';
    if (score >= 55) return 'fair';
    return 'poor';
  }

  /* ---- Circular gauge animation ---- */
  function animateGauge(el) {
    var score = parseInt(el.dataset.score, 10) || 0;
    var circumference = 2 * Math.PI * 90; // r=90
    var offset = circumference - (score / 100) * circumference;
    var fill = el.querySelector('.ax-gauge__fill');
    var number = el.querySelector('.ax-gauge__number');
    if (!fill || !number) return;

    fill.classList.add('ax-gauge__fill--' + getColorClass(score));

    // Animate number
    var current = 0;
    var duration = 1600;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      current = Math.round(eased * score);
      number.textContent = current;
      if (progress < 1) requestAnimationFrame(step);
    }

    // Delay slightly so observer triggers first
    setTimeout(function () {
      fill.style.strokeDashoffset = offset;
      requestAnimationFrame(step);
    }, 100);
  }

  /* ---- Progress bar animation ---- */
  function animateScoreBars(container) {
    var rows = container.querySelectorAll('.ax-score-row');
    rows.forEach(function (row, i) {
      var fill = row.querySelector('.ax-score-row__fill');
      var value = row.querySelector('.ax-score-row__value');
      var score = parseInt(row.dataset.score, 10) || 0;

      // Stagger reveal
      setTimeout(function () {
        row.classList.add('is-visible');
      }, i * 120);

      // Animate bar width
      setTimeout(function () {
        if (fill) {
          fill.classList.add('ax-score-row__fill--' + getColorClass(score));
          fill.style.width = score + '%';
        }
        // Animate number
        if (value) {
          var current = 0;
          var duration = 1000;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            current = Math.round(eased * score);
            value.textContent = current;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }
      }, i * 120 + 200);
    });
  }

  /* ---- Intersection Observer ---- */
  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show everything immediately
      document.querySelectorAll('.ax-gauge').forEach(animateGauge);
      document.querySelectorAll('.ax-scorecard__bars').forEach(animateScoreBars);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        if (el.classList.contains('ax-gauge')) {
          animateGauge(el);
        } else if (el.classList.contains('ax-scorecard__bars')) {
          animateScoreBars(el);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.ax-gauge').forEach(function (el) {
      observer.observe(el);
    });
    document.querySelectorAll('.ax-scorecard__bars').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Init ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
